import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle } from 'react-icons/fa';

const ThankYouPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 bg-gradient-to-br from-gray-50 to-blue-100">
      <div className="bg-white p-12 rounded-3xl shadow-xl text-center max-w-2xl w-full animate-fadeIn">
        <div className="mb-8 animate-pulse">
          <FaCheckCircle className="text-6xl text-green-500 mx-auto" />
        </div>
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          {t('thankYou.title')}
        </h1>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          {t('thankYou.message')}
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage; 